import { render, staticRenderFns } from "./HallListContainer.vue?vue&type=template&id=0f3626de"
import script from "./HallListContainer.vue?vue&type=script&lang=js"
export * from "./HallListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports